module.exports = __webpack_public_path__ + "img/adults-only.2.0533471.jpg";